import React from "react";
import {ReactSortable} from "react-sortablejs";
import NotebookTaskCard from "../task-card";


const SortableTaskColumns = ({
                                 list,
                                 groupName,
                                 onEnd,
                                 onRemoveTask,
                                 onEditTask,
                                 disabled,
                                 statusId,
                                 toggleTaskDoneStatus,
                                 setTask
                             }) => {

    return (
        <ReactSortable
            id={`task-status-${statusId}`}
            onEnd={onEnd}
            setList={() => void 0}
            list={list}
            group={groupName}
            animation={210}
            dragoverBubble
            disabled={disabled}
            ghostClass={'todo-list-ghost'}
            style={{
                minHeight: '700px',
                height: '100%'

            }}
        >
            {
                list.map(e => (
                    <NotebookTaskCard
                        key={e.id}
                        task={e}
                        disabled={disabled}
                        onRemove={onRemoveTask}
                        onEdit={onEditTask}
                        toggleTaskDoneStatus={toggleTaskDoneStatus}
                        setTask={(...args) => setTask(e.id, ...args)}
                    />
                ))
            }
        </ReactSortable>
    );
}

export default SortableTaskColumns;
